import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ReportsNavigationModel } from 'common/models/page-models/reports/reports-navigation/report-navigation-data-model';
import { ReportsNavigationListingModel } from 'common/models/page-models/reports/reports-navigation/report-navigation-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { ReportsNavigationWidgetService } from 'common/widget/reports/reports-navigation.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class ReportsNavigationResolver extends GridResolver<ReportsNavigationModel, ReportsNavigationListingModel> {
    constructor(
        protected fs: ReportsNavigationWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}